import { CellProps, Formatted, WithClassname } from '@jsonforms/core';
import { Input } from '@mantine/core';
import merge from 'lodash/merge';
import React, { useCallback } from 'react';
import { useDebouncedChange } from '../utils';
import { WithInputProps } from './interfaces';

export const MantineInputNumberFormat = React.memo(function MantineInputNumberFormat(
  props: CellProps & WithClassname & Formatted<number> & WithInputProps
) {
  const { className, id, enabled, uischema, isValid, path, handleChange, schema, config, label } = props;
  const maxLength = schema.maxLength;
  const appliedUiSchemaOptions = merge({}, config, uischema.options);
  let inputProps;
  if (appliedUiSchemaOptions.restrict) {
    inputProps = { maxLength: maxLength };
  } else {
    inputProps = {};
  }
  const formattedNumber = props.toFormatted(props.data);

  const validStringNumber = useCallback(
    (ev: any) => props.fromFormatted(ev.currentTarget.value),
    [props.fromFormatted]
  );
  const [inputValue, onChange] = useDebouncedChange(handleChange, '', formattedNumber, path, validStringNumber);

  return (
    <Input.Wrapper label={label}>
      <Input
        type='text'
        miw={200}
        maw={320}
        value={inputValue}
        onChange={onChange}
        className={className}
        id={id}
        disabled={!enabled}
        autoFocus={appliedUiSchemaOptions.focus}
        multiline={appliedUiSchemaOptions.multi}
        {...inputProps}
        error={!isValid}
      />
    </Input.Wrapper>
  );
});
